'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _components = require('../../components');

var _IyvListTable = require('./IyvListTable.css');

var _IyvListTable2 = _interopRequireDefault(_IyvListTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListTdGenderEqualityRank = (_dec = (0, _reactCssModules2.default)(_IyvListTable2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListTdGenderEqualityRank, _Component);

  //
  function IyvListTdGenderEqualityRank(props) {
    (0, _classCallCheck3.default)(this, IyvListTdGenderEqualityRank);

    //
    var _this = (0, _possibleConstructorReturn3.default)(this, (IyvListTdGenderEqualityRank.__proto__ || (0, _getPrototypeOf2.default)(IyvListTdGenderEqualityRank)).call(this, props));

    var grpLbl = '';
    switch (props.activeGrouping) {
      case 'rank':
        grpLbl = 'gef_rank';
        break;
      case 'peer':
        grpLbl = 'gef_peer';
        break;
      default:
        // 'group'
        grpLbl = 'gef_grp';
        break;
    }
    //
    _this.state = {
      grpLbl: grpLbl
    };
    return _this;
  }
  //


  (0, _createClass3.default)(IyvListTdGenderEqualityRank, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'td',
        {
          styleName: 'col',
          onClick: function onClick() {
            _this2.props.clickShareclass(_this2.props.shareclass);
          }
        },
        _react2.default.createElement(_components.GenderEqualityScoreLabel, {
          fund: this.props.shareclass,
          gefType: this.state.grpLbl
        })
      );
    }
  }]);
  return IyvListTdGenderEqualityRank;
}(_react.Component), _class2.propTypes = {
  shareclass: _react.PropTypes.object.isRequired,
  clickShareclass: _react.PropTypes.func.isRequired,
  activeGrouping: _react.PropTypes.string
}, _temp)) || _class);
exports.default = IyvListTdGenderEqualityRank;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListTable/IyvListTdGenderEqualityRank.js
// module id = 1377
// module chunks = 0